import Header from '@components/ItemPage/Layout/Header'
import { ReactNode } from 'react'
import Sidebar from '@components/ItemPage/Layout/Sidebar'

const Layout = ({ children }: { children: ReactNode }) => {
  return (
    <div className="w-full grid grid-cols-4 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-1">
      <div className="relative col-span-1">
        <Sidebar />
      </div>
      <div className="col-span-4 md:col-span-2 lg:col-span-3 xl:col-span-4 bg-white">
        <Header />
        <div className="mobile-padding">{children}</div>
      </div>
    </div>
  )
}

export default Layout
